<template>
  <div class="content-box">
    <div class="content">
      <div class="title-box">
        <span class="title">我的报名</span>
      </div>
      <div class="test-name" ref="fffff">
        <!--<span>2019上半年等级测试</span>-->
        <el-select
          v-model="matchId"
          size="mini"
          @change="getMsgList"
          placeholder="请选择赛事"
        >
          <!--<el-option label="2019上半年等级测试" value="1"></el-option>
            <el-option label="2019下半年等级测试" value="2"></el-option>-->
          <el-option
            v-for="item in listMatches"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <div class="tip">
          请选择要支付的报名信息后点击立即支付，务必在十五分钟内完成支付，超过规定时间将删除该订单并取消本次报名信息。
        </div>
        <!-- <el-button class="back-btn" size="mini" @click="jumper">返回报名</el-button> -->
      </div>

      <div :key="index" v-for="(firstItem, index) in firstClass">
        <template>
          <div class="table-box">
            <div class="search-box">
              <p>{{ firstItem.typesData }}</p>
            </div>
            <div class="table-content">
              <el-table
                :data="firstItem.tableData"
                size="mini"
                :ref="
                  firstItem.typesData &&
                  firstItem.typesData.indexOf('冰上舞蹈') != -1
                    ? 'multipleTable'
                    : ''
                "
                @select="changeSelect($event, index)"
                @select-all="changeSelect($event, index)"
                border
                :span-method="
                  firstItem.typesData &&
                  firstItem.typesData.indexOf('冰上舞蹈') != -1
                    ? objectSpanMethod
                    : notSpanMethod
                "
                style="width: 100%"
              >
                <el-table-column
                  type="selection"
                  :selectable="selectable"
                  width="55"
                >
                </el-table-column>

                <el-table-column label="编号" type="index" width="120">
                </el-table-column>

                <el-table-column prop="createTime" label="报名时间" width="250">
                </el-table-column>

                <el-table-column prop="userName" label="姓名" width="120">
                </el-table-column>

                <el-table-column
                  prop="gender"
                  label="性别"
                  :formatter="formatRole"
                  width="120"
                >
                </el-table-column>

                <!--<el-table-column
                    prop="gender"
                    :formatter="formatRole"
                    label="性别">
                  </el-table-column>-->

                <el-table-column
                  prop="cost"
                  label="证件号"
                  show-overflow-tooltip
                >
                </el-table-column>

                <el-table-column prop="userIdcode" label="费用">
                </el-table-column>

                <el-table-column label="支付状态">
                  <template slot-scope="scope">
                    <span
                      :style="{
                        color: scope.row.paystatus == 'N' ? '#5a5cbb' : '',
                      }"
                      >{{ scope.row.paystatus | formatPay }}</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="submit-box">
      <div style="width: 100%; background: #fdf6ec">
        <el-alert
          show-icon
          center
          description="请仔细核对报名信息，如果有误，后果自行承担！"
          title="警告提示语"
          type="warning"
          :closable="false"
        >
        </el-alert>
      </div>

      <div class="submit-content-box">
        <!--<input v-show="false" name="matchId" v-model="matchId"  type="text">-->
        <!--<input v-show="false" name="registrationInfoId" v-model="submitList"  type="text">-->
        <button
          @click="saveMoney"
          :class="{ disabledClass: submitList.length === 0 }"
          :disabled="submitList.length === 0"
        >
          立即支付
        </button>
        <p class="price-box">
          <span>合计：</span>
          <span class="total-price">￥{{ totalPrice }}</span>
        </p>
      </div>
    </div>
  </div>
  <!--    <button @click="jumper">返回报名</button>-->
</template>

<script>
import { get, post } from "@/api/fetch.js";
import url from "@/api/serviceAPI.config.js";
export default {
  name: "",
  data() {
    return {
      identity: "2", //（2=组织，3=个人）
      events: "1",
      orgId: "8104", //组织
      matchId: 3,
      totalPrice: 0,
      stationData: "",
      submitList: [],
      firstClass: [
        /* {
              typesData:[],           //类别
              typetotalPrice:0,
              typeSubmitList:[],
              tableData: [{
                cost: '',
                userName: '',
                gender: ''
              }]
            }*/
      ],
      listMatches: [],
      flag: true,
      arrangementIdList: [],
    };
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    notSpanMethod() {
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
    jumper() {
      this.$router.push({ path: "/index/applyPage", query: {} });
    },
    getEvents() {
      post(url.getStation, { matchId: 1 }).then((res) => {
        /*this.stationData=res.list;*/
      });
    },
    getMsgList() {
      this.orgId = JSON.parse(sessionStorage.getItem("userId"));
      this.identity = JSON.parse(sessionStorage.getItem("type"));
      post(url.getAllPayList, {
        matchId: this.matchId,
        orgId: this.orgId,
        personId: this.orgId,
        payStatus: "A",
        type: this.identity,
      }).then((res) => {
        this.firstClass = [];
        if (!res.data.length) {
          this.firstClass = [];
        }
        let { data, icRegis } = res;
        let icRegisData = this.dealIce(icRegis);
        console.log(icRegisData);
        for (let i in icRegisData) {
          let iceTeam = icRegisData[i];
          let obj = {
            typesData: "", //类别
            time: "",
            typetotalPrice: 0,
            typeSubmitList: [],
            tableData: [],
          };
          obj.typesData = i;
          for (let i in iceTeam) {
            let {
              personName,
              id,
              cost,
              gender,
              credentialsNo,
              payStauts,
              createTime,
              groupIndex,
              readIndex,
            } = iceTeam[i];
            obj.tableData.push({
              cost: credentialsNo, //身份证
              userName: personName,
              userIdcode: cost || 0,
              paystatus: payStauts,
              createTime,
              gender,
              groupIndex,
              readIndex,
              id: id,
            });
          }
          this.firstClass.push(obj);
        }

        for (let item of data) {
          let arrangement = item.arrangement;
          let registrationinfo = item.registrationinfo;

          let obj = {
            typesData: "", //类别
            time: "",
            typetotalPrice: 0,
            typeSubmitList: [],
            tableData: [],
          };
          for (let i in arrangement) {
            let classname = item.arrangement[i];
            if (classname && i.indexOf("attribute") != -1)
              obj.typesData += classname;
          }
          for (let i in registrationinfo) {
            let {
              personName,
              id,
              cost,
              gender,
              credentialsNo,
              payStauts,
              createTime,
              arrangementId,
            } = registrationinfo[i];
            obj.tableData.push({
              cost: credentialsNo, //身份证
              userName: personName,
              gender: gender,
              userIdcode: cost || 0,
              paystatus: payStauts,
              createTime: createTime,
              id: id,
              arrangementId,
            });
          }
          this.firstClass.push(obj);
        }
      });
    },
    dealIce(icRegis) {
      let icRegisDataZ;
      icRegis.forEach((item, index) => {
        icRegisDataZ = { ...icRegisDataZ, ...this.secondDeal(item) };
      });
      return icRegisDataZ;
    },
    secondDeal(data) {
      return data.reduce((prev, cur, index) => {
        let { arrangement, registrationinfo } = cur;
        registrationinfo.forEach((item, itemIndex) => {
          item.groupIndex = index;
          item.readIndex = index * 2 + itemIndex;
        });
        let { attribute1, attribute2, attribute3 } = arrangement;
        let attribute = attribute1 + attribute2 + attribute3;
        /*(prev[attribute]=prev[attribute]||[]).push(registrationinfo)*/
        prev[attribute] = [...(prev[attribute] || []), ...registrationinfo];
        return prev;
      }, {});
    },
    FileGroup(data, key) {
      return data.reduce(function (prev, cur) {
        (prev[cur[key]] = prev[cur[key]] || []).push(cur);
        return prev;
      }, {});
    },
    formatRole: function (row, column) {
      return row.gender == "1" ? "男" : row.gender == "2" ? "女" : "性别不详";
    },
    selectable(row, column) {
      if (row.paystatus == "Y") {
        //已支付
        return 0; //不可勾选
      } else if (row.paystatus == "P") {
        //支付中
        return 0; //不可勾选
      } else {
        return 1; //可勾选
      }
    },
    changeSelect(val, index) {
      let cloneVal = JSON.parse(JSON.stringify(val));
      let typetotalPrice = 0;
      let totalPrice = 0;
      let typeSubmitList = [];
      let submitList = [];
      let newVal = [];
      let arrangementIdList = [];
      if (this.firstClass[index].typesData.indexOf("冰上舞蹈") != -1) {
        //冰舞
        for (let item of cloneVal) {
          if (item.readIndex != item.groupIndex * 2) {
            //  先去掉隐藏的复选框
            this.$refs.multipleTable[index].toggleRowSelection(
              this.firstClass[index].tableData[item.readIndex],
              false
            );
          }
          // newVal.push(this.firstClass[index].tableData[item.groupIndex*2+1])
        }
        for (let item of cloneVal) {
          if (item.readIndex == item.groupIndex * 2) {
            this.$refs.multipleTable[index].toggleRowSelection(
              this.firstClass[index].tableData[item.groupIndex * 2 + 1],
              true
            );
          }
        }
      }

      // if(this.firstClass[index].typesData.indexOf('冰上舞蹈')!=-1){   //冰舞

      //   if(val.length==this.firstClass[index].tableData.length){        //全选
      //     newVal = []
      //   }else{
      //     for(let item of val){
      //     newVal.push(this.firstClass[index].tableData[item.groupIndex*2+1])
      //     }
      //   }
      // }

      // newVal=[...(newVal.length?newVal:[]),...val]

      for (var item of val) {
        arrangementIdList.push(item.arrangementId);
        typetotalPrice += parseInt(item.id);
        typeSubmitList.push(item.id);
      }
      this.firstClass[index].typetotalPrice = typetotalPrice; //单个table总价
      this.firstClass[index].typeSubmitList = typeSubmitList; //单个table勾选数据
      this.firstClass[index].arrangementIdList = arrangementIdList;
      arrangementIdList = [];
      for (var items of this.firstClass) {
        totalPrice += items.typetotalPrice;
        submitList = submitList.concat(items.typeSubmitList);
        arrangementIdList = arrangementIdList.concat(items.arrangementIdList);
      }
      /*this.totalPrice=totalPrice;*/ //前端计算金额
      this.submitList = submitList;
      this.arrangementIdList = arrangementIdList.filter((item) => !!item);
      post(url.countMoney, { registrationInfoId: this.submitList }).then(
        (res) => {
          this.totalPrice = res;
        }
      );
    },
    select(selection, row) {},
    saveMoney() {
      post(url.saveMoney, {
        registrationInfoId: this.submitList,
        matchId: this.matchId,
        id: this.orgId,
        createType: this.identity,
        arrangementId: this.arrangementIdList,
      }).then((res) => {
        if (res.status !== 500) {
          this.$router.push({
            path: "choosePayWay",
            query: { orderNo: res.orderNo, money: this.totalPrice },
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getGameLists() {
      post(url.listMatche).then((res) => {
        this.listMatches = res.data;
        this.matchId = this.listMatches[this.listMatches.length - 1].id;
        this.getMsgList();
      });
    },
  },
  filters: {
    formatPay: function (paystatus) {
      return paystatus == "N"
        ? "未支付"
        : paystatus == "Y"
        ? "已支付"
        : paystatus == "P"
        ? "支付中"
        : "订单异常";
    },
  },
  created() {
    this.getGameLists();
  },
};
</script>

<style type="text/scss" lang="scss" scoped>
div {
  color: #000;
}
.table-box {
  margin-bottom: 20px;
}
.title-box {
  font-size: 18px;
  height: 50px;
  line-height: 50px;
  margin: 15px 0 0px;
  border-bottom: 2px solid #e8e8e8;
  .title {
    color: #5a5cbb;
    border-bottom: 2px solid #5a5cbb;
    padding: 13px 35px 13px 25px;
    font-weight: 600;
  }
}
.test-name {
  height: 40px;
  background: #f6f6f6;
  color: #000;
  font-size: 14px;
  padding-left: 25px;
  line-height: 40px;
  display: flex;
  gap: 50px;

  .back-btn {
    float: right;
    background: #5a5cbb;
    border: none;
    color: #fff;
    margin: 7px;
  }
  .tip {
    color: red;
  }
}
.search-box {
  height: 50px;
  background: #eaf8ff;
  line-height: 50px;
  border: 1px solid #e8e8e8;
  padding-left: 25px;
  border-bottom: none;
}
.table-content {
  padding: 20px;
  border: 1px solid #e8e8e8;
}

.submit-box {
  width: 100%;
  height: 116px;
  background: #e5e5e5;
  position: fixed;
  bottom: 0;
  z-index: 9;
  .submit-content-box {
    width: 1200px;
    margin: 0 auto;
    button {
      height: 55px;
      background: #5a5cbb;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      width: 160px;
      float: right;
      border: none;
      cursor: pointer;
    }
    .disabledClass {
      background: #ccc;
      color: #fff;
      cursor: not-allowed;
    }
    .price-box {
      float: right;
      line-height: 56px;
      height: 56px;
      font-size: 14px;
      .total-price {
        color: #5a5cbb;
        font-size: 20px;
        font-weight: 700;
        margin-right: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classStatus.vue